import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import branch from 'branch-sdk';
import { useSelector } from 'react-redux';

const BranchListener = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.login.isAuthenticated);

  useEffect(() => {
    console.log('[BranchListener] Initializing Branch deep link listener NEW');

    branch.init('key_live_aFhXqy0CNUR22lnOcqB2RpgiEzbdVs9x', async (err, data) => {
      if (err) {
        console.error('[BranchListener] Branch init error', err);
        if (location.pathname === '/session-expired') {
          console.log('[BranchListener] User on session-expired page, skipping error redirect');
          return;
        }
        return;
      }

      console.log('[BranchListener] Branch init success', data);
      console.log('[BranchListener] isAuthenticated:', isAuthenticated);

      if (isAuthenticated) {

          // ✅ Inject mock data ONLY during local development          
          // if (data.data=="" ) {
          //     console.warn('[BranchListener] No data received from Branch. Using mock data for local testing.');
        
          //     data = {
          //         data: "{\"+match_guaranteed\":true,\"~creation_source\":0,\"+clicked_branch_link\":true,\"+click_timestamp\":1747906519,\"~id\":1443921987943807980,\"~referring_browser\":\"Chrome\",\"+is_first_session\":false,\"campaign\":\"winfertility-companion\",\"custom_meta_tags\":\"{\\\"MemberID\\\":\\\"40055545_20\\\",\\\"AppUserID\\\":\\\"Greystar-Reimbursement Program\\\",\\\"PageName\\\":\\\"Wincentive\\\"}\",\"~referring_link\":\"https://winfertility.app.link/qIQZbuclPSb?__branch_flow_id=1454032208830784017&~referring_browser=Chrome\"}",
          //         data_parsed: {
          //         "+match_guaranteed": true,
          //         "~creation_source": 0,
          //         "+clicked_branch_link": true,
          //         "+click_timestamp": 1747906519,
          //         "~id": 1443921987943808000,
          //         "~referring_browser": "Chrome",
          //         "+is_first_session": false,
          //         "campaign": "winfertility-companion",
          //         "custom_meta_tags": JSON.stringify({
          //           MemberID: "40055545_20",
          //           AppUserID: "Greystar-Reimbursement Program",
          //           PageName: "PhoneVideoConsult"
          //         }),
          //         "~referring_link": "https://winfertility.app.link/qIQZbuclPSb?__branch_flow_id=1454032208830784017&~referring_browser=Chrome"
          //       }
          //     };
          //   }
          // ✅ Inject mock data schedule appointment ONLY during local development
          //  debugger;
       
        console.log('[BranchListener] Branch init success after Authenticated', data);

        if (data.data && data.data_parsed) {
          let screen = data.data_parsed.screen;
          let supportCardType = data.data_parsed.supportCardType;
          let videoLink, documentLink, articleLink = "";
          let nonPhysicianProvider = "";
          let slotType, advocateConsultType = "";

          // 1. Parse custom_meta_tags if screen is missing
          if (!screen && typeof data.data_parsed.custom_meta_tags === 'string') {
            try {
              const meta = JSON.parse(data.data_parsed.custom_meta_tags);
              console.log('[BranchListener] Parsed custom_meta_tags:', meta);

              if (meta.PageName) {
                screen = meta.PageName.trim();
                supportCardType = meta.SupportCardType;
                videoLink = meta.VideoLink;
                documentLink = meta.DocumentLink;
                articleLink = meta.ArticlesLink;
                nonPhysicianProvider = meta.NonphysicianProivder;
                slotType = meta.SlotType;
                advocateConsultType = meta.AdvocateConsultType;
                console.log(`[BranchListener] Using PageName from custom_meta_tags as screen: ${screen}`);
              }
            } catch (e) {
              console.warn('[BranchListener] Failed to parse custom_meta_tags:', e);
            }
          }

          // 2. Normalize and navigate
          if (screen && typeof screen === 'string') {
            const normalizedScreen = screen.charAt(0).toUpperCase() + screen.slice(1);
            console.log(`[BranchListener] Navigating to screen: ${normalizedScreen}`);

            if (normalizedScreen === "SelectDateConsult" && typeof data.data_parsed.custom_meta_tags === 'string') {
              try {
                const meta = JSON.parse(data.data_parsed.custom_meta_tags);
                const SlotType = meta.SlotType;
                console.log(`[BranchListener] Extracted SlotType: ${SlotType}`);

                let selectedType = SlotType;
                if (SlotType && SlotType.includes('-')) {
                  selectedType = SlotType.split('-')[0];
                  console.log(`[BranchListener] Derived selectedType: ${selectedType} from SlotType: ${SlotType}`);
                }

                navigate('/calendar-view', { state: { SlotType, selectedType } });
                return;
              } catch (e) {
                console.warn('[BranchListener] Failed to parse custom_meta_tags for SelectDateConsult:', e);
              }
            }

            console.log(`[BranchListener] Navigating to screen: ${normalizedScreen}`);
            navigateToScreen(normalizedScreen, supportCardType, videoLink, documentLink, articleLink, nonPhysicianProvider, slotType, advocateConsultType, navigate, isAuthenticated);
          } else {
            console.warn('[BranchListener] No valid screen found. Redirecting to /home');
            if (location.pathname === '/session-expired') {
              console.log('[BranchListener] User on session-expired page, skipping home redirect');
              return;
            }
            navigate('/home');
          }
        }
      } else {
        // Don't redirect if user is on session-expired page
        if (location.pathname === '/session-expired') {
          console.log('[BranchListener] User on session-expired page, skipping redirect');
          return;
        }
  
        if (data.data && data.data_parsed) {
          let screen = data.data_parsed.screen;
          let supportCardType = data.data_parsed.supportCardType;
          let videoLink, documentLink, articleLink = "";
          let nonPhysicianProvider = "";
          let slotType, advocateConsultType = "";

          // 1. Parse custom_meta_tags if screen is missing
          if (!screen && typeof data.data_parsed.custom_meta_tags === 'string') {
            try {
              const meta = JSON.parse(data.data_parsed.custom_meta_tags);
              console.log('[BranchListener] Parsed custom_meta_tags:', meta);
              if (meta.PageName) {
                screen = meta.PageName.trim();
                videoLink = meta.VideoLink;
                documentLink = meta.DocumentLink;
                articleLink = meta.ArticlesLink;
                supportCardType = meta.SupportCardType;
                nonPhysicianProvider = meta.NonphysicianProvider;
                slotType = meta.SlotType;
                advocateConsultType = meta.AdvocateConsultType;
                console.log(`[BranchListener] Using PageName from custom_meta_tags as screen: ${screen}`);
                const normalizedScreen = screen.charAt(0).toUpperCase() + screen.slice(1);
                navigateToScreen(normalizedScreen, supportCardType, videoLink, documentLink, articleLink, nonPhysicianProvider, slotType, advocateConsultType, navigate, isAuthenticated);
              }
            } catch (e) {
              console.warn('[BranchListener] Failed to parse custom_meta_tags:', e);
              navigate('/login');
            }
          }
        }
      }
    });
  }, [location, navigate, isAuthenticated]);

  return null;
};

// Remove useSelector from here and pass it down
const navigateToScreen = (screen, supportCardType, videoLink, documentLink, articleLink, nonPhysicianProvider, slotType, advocateConsultType, navigate, isAuthenticated) => {
  const routeMap = {
    Login: '/login',
    ForgotPassword: '/forgotpassword',
    ResetPassword: '/resetpassword',
    NotificationPreferences: '/notification-preference',
    UpdatePhoneNumber: '/updatephonenumber',
    UpdateProfileInformation: '/edit-UpdateProfileInformation',
    InsuranceCardUpload: '/insurenceupload',
    PrivacyPolicy: '/PrivacyPolicy',
    TermsAndConditions: '/TermsAndConditions',
    Me: '/edit-healthprofilesetup',
    Benefits: '/benefits-landingpage',
    BenefitDetails: '/benefit-details',
    BenefitAccumulator: '/benefits-accumulator',
    TreatmentAuthorizations: '/treatment-authorization',
    TreatmentCostEstimatier: '/benefits-treatmentcostestimator',
    MyDocuments: '/benefits-mydocuments',
    RXAuthorizations: '/benefits-rxauthorization',
    PHIForm: '/benefits-phiform',
    PatientID: '/benefit-patientid',
    FindCare: '/find-care',
    BookAnAppointment: '/book-appointment',
    FindAProvider: '/load-findcare-list',
    PhoneVideoConsult: '/book-appointment',
    SelectDateConsult: '/calendar-view',
    ReproductiveEndocrinologists: '/load-findcare-list',
    Doulas: screen == "Doulas" && nonPhysicianProvider == "Doulas" ? '/load-findcare-list' : '/support-services',
    Chat: '/chat-bot',
    Notifications: '/notifications',
    UpcomingAppointments: '/appointment-cancellation-reschedule',
    Education: '/continuereading',
    PregnancySymptomTracker: '/pregnancy',
    WeeklyPregnancyTracker: '/weekly-pregnancy-tracker',
    Webinars: '/play-video',
    Wincentive: '/incentive-landingpage',
    RewardHistory: '/incentive-rewardshistory',
    Achievements: '/incentive-achievementdetails',
    MyWinCard: '/pay-cards',
    WinPay: '/pay-landingpage',
    Home: '/home',
    Support: '/support-services',
    MyWINCards: '/pay-cards',
    RequestnewWINCard: '/pay-cards',
    UploadSupportingDocument: '/pay-supportservicedocument',
    RequestReimbursement: '/pay-reimbursement',
    MyBenefitWINCard: '/pay-cards',
    MyWINCentiveWINCard: '/pay-cards',
    Treatment: '/feedServices',
    RequestNewAuthorization: '/verbal-authorization',
    BIPOC: '/support-services',
    Maternity: '/maternity-assessment',
    Fertility: '/support-services',
    Preconception: '/prepregnancydetails',
    BehaviouralHealth: '/bhassessment',
    Nutrition: '/support-services',
    ChildDevelopment: '/support-services',
    CaregiverSupport: '/support-services',
    MensHealth: '/support-services',
    Surrogacy: '/support-services',
    WomensHealth: '/support-services',
    Adoption: '/support-services',
    Prescriptions: '/rx-authorization',
    FertilityTracker: '/fertility',
    MenopauseTracker: '/menopause',
    AndropauseTracker: '/andropause',
    ShareMyStory: '/incentive-story',
    PregnancyAssessment: '/maternity-assessment',
    BHAssessment: '/bhassessment',
    Resources: "/feedServices",
    ProviderSearch: "/load-findcare-list",
    ConsultRating: "/consultation-rating",
    ChildResources: "/book-appointment",
    PhysicianProviders: "/review-rx"
  };

  console.log("navigateToscreen, screen : ", screen, "routeMap[screen] : ", routeMap[screen])
  if (routeMap[screen]) {
    console.log(`[BranchListener] Found route for screen: ${screen}, navigating to: ${routeMap[screen]}`);
    if (routeMap[screen] === "/support-services") {
      const updatedLink = {
          originalText: supportCardType || "",
          displayText: supportCardType || "",
          isBranchIORedirection: true,
        };
      if (isAuthenticated) {
        navigate("/home", { state : { subRedirection: routeMap[screen], updatedLink: updatedLink}});
      } else {
        navigate('/login', { state: { subRedirection: routeMap[screen], updatedLink: updatedLink } });
      }
    } else if (routeMap[screen] === "/feedServices") {
      const mediaLink = {
          videolink: videoLink || "",
          documentlink: documentLink || "",
          articlelink: articleLink || "",
        };
      if (isAuthenticated) {
        navigate("/home", { state : { subRedirection: routeMap[screen], mediaLink: mediaLink}});
      } else {
        navigate('/login', { state: { subRedirection: routeMap[screen], mediaLink: mediaLink } });
      }
    } else if (routeMap[screen] === "/find-care") {
        if (isAuthenticated) {
          navigate("/home", { state : { subRedirection: routeMap[screen], nonPhysicianProvider: nonPhysicianProvider}});
        } else {
          navigate('/login', { state: { subRedirection: routeMap[screen], nonPhysicianProvider: nonPhysicianProvider } });
        }
    } else if (routeMap[screen] === "/book-appointment") {
        if (isAuthenticated) {
          navigate("/home", { state : { subRedirection: routeMap[screen], slotType: slotType, advocateConsultType: advocateConsultType}});
        } else {
          navigate('/login', { state: { subRedirection: routeMap[screen], slotType: slotType, advocateConsultType: advocateConsultType } });
        }
    } else if (routeMap[screen] === "/load-findcare-list") {
        navigate(routeMap[screen], {state: { nonPhysicianProvider }});
    } else {
      navigate(routeMap[screen]);
    }
  }  else {
    console.log(`[BranchListener] No route found for screen: ${screen}, navigating to default /home`);
    navigate('/home');
  }
};

export default BranchListener;
